<header>
  <div class="controls controls-start">
    <button [class.hidden]="!showBackButton" class="button-previous" (click)="goBackClicked()">
      <span class="sr-only" trans="topmenu.back"></span>
      <mat-icon class="icon">arrow_back</mat-icon>
    </button>
  </div>

  <div class="logo-container">
    <div class="logo"></div>
    <span class="sr-only" role="heading" aria-level="1" trans="topmenu.logo.alt"></span>
  </div>

  <div class="controls controls-end">
    @if (showSwitchUser) {
      <button class="button-switch-user" (click)="switchUserClicked()">
        <span class="sr-only" trans="topmenu.switch_user"></span>
        <mat-icon class="icon">switch_account</mat-icon>
      </button>
    }

    <app-color-scheme-mini-picker></app-color-scheme-mini-picker>

    <app-language-button></app-language-button>

    <button class="button-help" routerLink="/help/faq">
      <span class="sr-only" trans="topmenu.help"></span>
      <mat-icon class="icon">help</mat-icon>
    </button>
  </div>
</header>
